import { SlotGameType1_2 } from "../SlotGameType1_2";

// namespace SlotGames2
// {
	export class RoyalKingDeluxe2 extends SlotGameType1_2
	{  		
	}




	// class RoyalKingDeluxeSecondScreenHelpFactory extends SlideFactory
	// {
	// 	public CreateStyle():Partial<CSSStyleDeclaration>
	// 	{
	// 		let style :Partial<CSSStyleDeclaration> = 
	// 		{
	// 			color:"White"
	// 		};
	// 		return style;
	// 	}
	// }
	
// }